import { render, staticRenderFns } from "./SixthComponent.vue?vue&type=template&id=7278d1de"
import script from "./SixthComponent.vue?vue&type=script&lang=js"
export * from "./SixthComponent.vue?vue&type=script&lang=js"
import style0 from "./SixthComponent.vue?vue&type=style&index=0&id=7278d1de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports